export default {
  welcomeUser: "Bienvenid@ {{name}} ({{role}})",
  selectOption: "selecciona la opcion deseada",
  closeMessage: "Cerrar mensaje",
  mode: {
    operateAs: "Operar como",
    professional: "Profesional",
    patient: "Paciente",
  },
  unreadMessages: "{{count}} mensajes sin leer",
  inventoryReorder: "Tenés insumos por reponer",
  inventoryExpiring: "Tenés insumos por vencer",
  inventoryReorderAndExpiring: "Tenés insumos por reponer y por vencer",
  pendingValidation:
    "Tu cuenta profesional está pendiente de validación. Para continuar ingresá en Settings, completá tus datos, incluyendo fotos denfrente y dorso del DNI y realiza la suscripción para tener los 15 días de prueba sin cargo. Una vez que administración valide la información, te enviará un mensaje para operar libremente.",
  comingSoonNotifications:
    "Próximamente podrás enviarle a todos tus pacientes mensajes por Whatsapp o Email con un solo click!",
  comingSoonClinicalHistory:
    "Próximamente. Estamos mejorando la experiencia.",
  nav: {
    configureSchedule: "Configurar Horarios",
    viewAppointments: "Ver Turnos",
    assignAppointments: "Asignar Turnos",
    shareSchedules: "Compartir Horarios",
    clinicalHistory: "Historias Clínicas",
    inventory: "Inventario",
    waitingRoom: "Recepción de Pacientes",
    notifications: "Notificaciones",
    informedConsent: "Consentimiento Informado",
    sharedSchedules: "Turnos y Horarios Compartidos",
    institutionSchedules: "Horarios Compartidos",
    messaging: "Mensajería",
    administration: "Administración",
    bookAppointment: "Reservar Turno",
    myAppointments: "Mis Turnos",
    bookAsPatient: "Reservar Turno (como paciente)",
    myAppointmentsAsPatient: "Mis Turnos (como paciente)",
    myStudies: "Mis Estudios",
  },
};
